import { openDialog } from '../base/dialog/actions';
import { isMobileBrowser } from '../base/environment/utils';
import { getLocalVietMeetDesktopTrack } from '../base/tracks/functions';
import CameraCaptureDialog from './CameraCaptureDialog';
import { SET_SCREENSHOT_CAPTURE } from './actionTypes';
import { createScreenshotCaptureSummary } from './functions';
import logger from './logger';
let screenshotSummary;
/**
 * Marks the on-off state of screenshot captures.
 *
 * @param {boolean} enabled - Whether to turn screen captures on or off.
 * @returns {{
    *      type: START_SCREENSHOT_CAPTURE,
    *      payload: enabled
    * }}
*/
function setScreenshotCapture(enabled) {
    return {
        type: SET_SCREENSHOT_CAPTURE,
        payload: enabled
    };
}
/**
* Action that toggles the screenshot captures.
*
* @param {boolean} enabled - Bool that represents the intention to start/stop screenshot captures.
* @returns {Promise}
*/
export function toggleScreenshotCaptureSummary(enabled) {
    return async function (dispatch, getState) {
        const state = getState();
        if (state['features/screenshot-capture'].capturesEnabled !== enabled) {
            if (!screenshotSummary) {
                try {
                    screenshotSummary = await createScreenshotCaptureSummary(state);
                }
                catch (err) {
                    logger.error('Cannot create screenshotCaptureSummary', err);
                }
            }
            if (enabled) {
                try {
                    const vietmeetTrack = getLocalVietMeetDesktopTrack(state);
                    await screenshotSummary.start(vietmeetTrack);
                    dispatch(setScreenshotCapture(enabled));
                }
                catch {
                    // Handle promise rejection from {@code start} due to stream type not being desktop.
                    logger.error('Unsupported stream type.');
                }
            }
            else {
                screenshotSummary.stop();
                dispatch(setScreenshotCapture(enabled));
            }
        }
        return Promise.resolve();
    };
}
/**
 * Opens {@code CameraCaptureDialog}.
 *
 * @param {Function} callback - The callback to execute on picture taken.
 * @param {ICameraCapturePayload} componentProps - The camera capture payload.
 * @returns {Function}
 */
export function openCameraCaptureDialog(callback, componentProps) {
    return (dispatch) => {
        if (!isMobileBrowser()) {
            return;
        }
        dispatch(openDialog('CameraCaptureDialog', CameraCaptureDialog, {
            callback,
            componentProps
        }));
    };
}
